import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Container from '../components/layout/Container';
import CompetitionList from '../components/competitions/CompetitionList';
import Button from '../components/common/Button';
import { useAuth } from '../hooks/useAuth';
import { getCompetitions } from '../services/public-api';
import './CompetitionsPage.css';

/**
 * CompetitionsPage
 * Lists all competitions for public viewing
 * T071: Competitions page listing all competitions
 */
const CompetitionsPage = () => {
  const { isOrganizer } = useAuth();
  const [competitions, setCompetitions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchCompetitions();
  }, []);

  const fetchCompetitions = async () => {
    setLoading(true);
    setError(null);

    try {
      const data = await getCompetitions();
      setCompetitions(data.competitions || []);
    } catch (err) {
      setError(err.message || 'Failed to load competitions');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <div className="competitions-page">
        <div className="page-header">
          <div>
            <h1>Competitions</h1>
            <p className="page-description">
              Browse all pool tournaments and leagues
            </p>
          </div>
          {isOrganizer && (
            <Link to="/organizer/competitions/create" className="btn btn-primary">
              + Create Competition
            </Link>
          )}
        </div>

        <CompetitionList
          competitions={competitions}
          loading={loading}
          error={error}
          onRetry={fetchCompetitions}
        />
      </div>
    </Container>
  );
};

export default CompetitionsPage;
